import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Box, VStack, Image, Text } from '@chakra-ui/react';

import { useColors } from './colors';
import { getMarketplaceLogo } from '../../../../components/marketplaceLogo';

import { getMarketplacesListApi } from 'features/marketplaces/marketplaces.api';

const MarketplaceSelector = ({ selectedMarketplace, onSelect }) => {
  const dispatch = useDispatch();

  const { list: marketplaceOptions } = useSelector((state) => state.marketplaces);

  useEffect(() => {
    dispatch(getMarketplacesListApi());
  }, [dispatch]);

  const { backgroundCardColor, textColor, selectedBgColor } = useColors();

  return (
    <Box w={{ base: '100%', md: '30%' }}>
      <Text fontSize="xl" fontWeight="semibold" mb={4} color={textColor}>
        Select Marketplace
      </Text>
      <VStack spacing={4} align="stretch">
        {marketplaceOptions.map((option) => (
          <Box
            key={option.id}
            cursor="pointer"
            onClick={() => onSelect(option.id)}
            bg={selectedMarketplace === option.id ? selectedBgColor : backgroundCardColor}
            border="1px solid"
            borderColor={selectedMarketplace === option.id ? 'blue.500' : 'transparent'}
            borderRadius="xl"
            p={6}
            transition="all 0.2s"
            _hover={{
              shadow: 'md',
              borderColor: 'blue.400',
            }}
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <Image
              src={getMarketplaceLogo(option.label)}
              alt={option.label}
              h="40px"
              objectFit="contain"
            />
          </Box>
        ))}
      </VStack>
    </Box>
  );
};

export default MarketplaceSelector;
